import { APP_INITIALIZER } from '@angular/core';
import { ConfigService, RecaptchaV3Service } from '@hohr/config';
import { AppConfigService } from './core/config/config.service';

const appInitializerFn = (
  appConfigService: AppConfigService,
  configService: ConfigService,
  recaptchaV3Service: RecaptchaV3Service
) => {
  return async () => {
    await appConfigService.loadConfig();

    const config = await configService.loadConfig(appConfigService.baseApiUrl, appConfigService.apimSubscriptionKey);

    if (!config) {
      configService.auth0InitializerFn(null);
    } else {
      recaptchaV3Service.load(config.keys?.googleRecaptchaSiteKey);

      // Initialize Auth0
      configService.auth0InitializerFn(null, {
        domain: configService?.config?.security?.auth0?.domain,
        clientId: configService?.config?.security?.auth0?.clientId,
        authorizationParams: {
          scope: 'openid profile email offline_access',
          audience: configService?.config?.security?.auth0?.audience,
          redirect_uri: `${window.location.origin}`,
        },
        httpInterceptor: {
          allowedList: [
            `/assessment/*`,
            '/common/*',
            `/membership/*`,
            `/profile/*`,
            `/resume/*`,
          ].map((route) => `${appConfigService.baseApiUrl}${route}`),
        },
      });
    }
  };
};

export const APP_PROVIDERS = [
  {
    provide: APP_INITIALIZER,
    useFactory: appInitializerFn,
    multi: true,
    deps: [AppConfigService, ConfigService, RecaptchaV3Service],
  },
];
